import { render, staticRenderFns } from "./ServiceRequestServicesSection.vue?vue&type=template&id=2d4744b6&scoped=true"
import script from "./ServiceRequestServicesSection.vue?vue&type=script&lang=js"
export * from "./ServiceRequestServicesSection.vue?vue&type=script&lang=js"
import style0 from "./ServiceRequestServicesSection.vue?vue&type=style&index=0&id=2d4744b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4744b6",
  null
  
)

export default component.exports